import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
  ({
    yearCalendar: {
      padding: '6px',
      border: 'none',
    },
  }));

export default useStyles;
